import {
  AppPaths,
  AppRoutes,
  RedirectRoutes,
} from '../../../../../utils/mapping/appRoutes.mapping';

/**
 * Mapa de relaciones entre rutas de redirección (detalles, formularios)
 * y la ruta principal del menú lateral que debe permanecer activa.
 * * Formato: [Ruta_Actual]: Ruta_Padre_en_Menu
 */
export const SIDEBAR_REDIRECT_MAP: Record<string, string> = {
  // [AppRoutes.myTickets]: AppRoutes.myTickets,
  // [AppRoutes.attendTicket]: AppRoutes.attendTicket,
  // [AppRoutes.approveTicket]: AppRoutes.approveTicket,
  // [RedirectRoutes.createTicket]: AppRoutes.myTickets,
  // [AppRoutes.recordScheduledVisits]: AppRoutes.scheduledVisits,

  [RedirectRoutes.myTickets]: AppRoutes.myTickets,
  [RedirectRoutes.createTicket]: AppRoutes.createTicket,
  [`/${AppPaths.helpdesk}/${AppPaths.attendTicket}`]: AppRoutes.attendTicket,
  [`/${AppPaths.helpdesk}/${AppPaths.approveTicket}`]: AppRoutes.approveTicket,
  [`/${AppPaths.contacts}`]: AppRoutes.contacts,
  [`/${AppPaths.helpdesk}/${AppPaths.contacts}`]: AppRoutes.contacts,
  [RedirectRoutes.myRequests]: AppRoutes.requests,
  [RedirectRoutes.myRequestsSumary]: AppRoutes.requestsSumary,
  [RedirectRoutes.myConsolidatedMaterials]: AppRoutes.consolidatedMaterials,
  [RedirectRoutes.myConsolidatedRecipe]: AppRoutes.consolidatedRecipe,
  [RedirectRoutes.myConsolidatedVersion]: AppRoutes.consolidatedVersion,
  [RedirectRoutes.myTypeMaterials]: AppRoutes.typeMaterials,
  [RedirectRoutes.myLoadMaterial]: AppRoutes.loadMaterial,
  [RedirectRoutes.myResources]: AppRoutes.resources,
  [RedirectRoutes.mySpeedTrefilado]: AppRoutes.speedTrefilado,
  [RedirectRoutes.mySpeedPlastificado]: AppRoutes.speedPlastificado,
  [RedirectRoutes.mySpeedVarilla]: AppRoutes.speedVarilla,
  [RedirectRoutes.mySpeedAlambreGalvanizado]: AppRoutes.speedAlambreGalvanizado,
  [RedirectRoutes.mySkuMallaOlimpica]: AppRoutes.skuMallaOlimpica,
  [RedirectRoutes.mySkuMallaOlimpicaPlastificada]:
    AppRoutes.skuMallaOlimpicaPlastificada,
  [RedirectRoutes.myIndicators]: AppRoutes.indicators,
};
